/**
 * Builds a quoted-reply object from a coach-task activity's messageId and messagePreview.
 *
 * The consume side requires: id, text, userId, attachments, internalText (send path in
 * ChannelMessageInput) and text, attachments, internalText (ReplyMessagePreview).
 *
 * We return a plain object rather than a ChatMessage instance because the ChatMessage
 * constructor calls firestorter's Document constructor which calls getFirestore().doc()
 * immediately — making it unsafe to instantiate outside a live Firebase context.
 * ReplyMessagePreview's PropType was widened (instanceOf(ChatMessage) | shape({…})) to accept
 * this plain object, so no PropType warning is raised; all consumed fields are satisfied.
 *
 * @param {object} activity - A coach-task activity object.
 * @param {string} [activity.messageId] - The Firestore ID of the linked chat message.
 * @param {object} [activity.messagePreview] - The denormalized message preview stored on the task.
 * @param {string} [activity.messagePreview.text] - The message text.
 * @param {string} [activity.messagePreview.senderUserId] - The sender's user ID.
 * @param {Array}  [activity.messagePreview.attachments] - Full attachment objects.
 * @param {string} [activity.messagePreview.internalText] - Internal (coach-only) text, if any.
 * @returns {{ id: string, text: string, userId: string, attachments: Array, internalText: string } | null}
 */
const buildQuotedMessageFromActivity = (activity = {}) => {
  const { messageId, messagePreview } = activity;

  if (!messageId || !messagePreview) {
    return null;
  }

  const {
    text = '',
    senderUserId = '',
    attachments = [],
    internalText = '',
  } = messagePreview;

  return {
    id: messageId,
    text,
    userId: senderUserId,
    attachments,
    internalText,
  };
};

export { buildQuotedMessageFromActivity };
export default buildQuotedMessageFromActivity;
